const items = [
  "WMS — Warehouse Management",
  "Smart-In POS",
  "Attendance App",
  "FastVi",
  "Sarmaya-AI",
  "Built by Smart-In",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="marquee overflow-hidden bg-[#020617] py-5">
    <div className="marquee-track flex w-max items-center">
      {[...items, ...items].map((text, i) => (
        <span
          key={i}
          aria-hidden={i >= items.length}
          className="flex items-center gap-10 pr-10 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-white/60"
        >
          {text}
          <span className="h-1.5 w-1.5 rounded-full bg-[#F59E0B]" />
        </span>
      ))}
    </div>
  </div>
);
